import { useParams } from 'react-router';
import { folderResolutionQuery } from '@/entities/guideline';
import { useCurrentWorkspaceId } from '@/entities/workspace';
import { GuidelinesWorkspace } from '@/features/guidelines';
import { Loading } from '@/shared/ui';
import { useDeepLinkResolution } from '@/shared/hooks';

export const FolderGuidelines = () => {
  const workspaceId = useCurrentWorkspaceId();
  const { folderId } = useParams<{ folderId: string }>();

  const resolution = useDeepLinkResolution({
    resolutionQuery: folderResolutionQuery(folderId),
    enabled: !!folderId,
  });

  if (!workspaceId) return <Loading />;

  return <GuidelinesWorkspace resolution={resolution} />;
};

FolderGuidelines.displayName = 'FolderGuidelines';
